import React, { useState, useEffect, useRef } from 'react';

import { DisableButton } from 'utils/DisableButton';
import { ColoredSelectProps } from './interface';

import * as S from "./styles";

const ColoredSelect = (props: ColoredSelectProps) => {
	const {
		distributionCenterList,
		value,
		setSelected,
		disabled,
		lengthQuoteItem,
		index
	} = props;

	const [opened, setOpened] = useState(false);

	const selectRef: any = useRef(null);

	const itemCd = distributionCenterList?.find((cd: any) => cd.local === value);

	function handleClickOutside(event: any) {
		if (selectRef.current && !selectRef.current.contains(event.target)) {
			setOpened(false);
		}
	}

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [selectRef]);

	return (
		<S.ColoredSelect opened={opened} lengthQuoteItem={lengthQuoteItem} index={index}>
			<div
				data-testid="select"
				className="select" ref={selectRef} onClick={() => disabled === false && setOpened(opened => !opened)}
			>
				<span
					className={`text selected box-wrapper ${(itemCd?.stock > 0 ? "" : " emptystockselected ")} ${(itemCd?.idealBilling ? " idealbillingdcselected " : "")} ${DisableButton(disabled)}`}
				>
					{value}
					<svg className="DCDropdwn-img" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.42834 5.71398C3.68727 6.14554 4.31273 6.14554 4.57166 5.71398L7.3942 1.00975C7.66081 0.565396 7.34073 8.16862e-05 6.82254 8.17768e-05L1.17746 8.27638e-05C0.659263 8.28544e-05 0.339187 0.565397 0.605797 1.00975L3.42834 5.71398Z" />
					</svg>

				</span>
				<div className="options-container" style={{ display: opened ? "flex" : "none" }}>
					{
						distributionCenterList && distributionCenterList?.map((item: any, index: number) => {
							return (
								<span
									data-testid="selectColor"
									className={"text box-wrapper options " + (item.stock > 0 ? "" : "emptystock")}
									onClick={() => { setSelected(item.local); }}
									key={index}
								>
									{item.local}
									{item.idealBilling &&
										<svg
											className="DCIdealBilling-img"
											width="10" height="10"
											viewBox="0 0 10 10"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M5 1L6.236 3.504L9 3.908L7 5.856L7.472 8.608L5 7.308L2.528 8.608L3 5.856L1 3.908L3.764 3.504L5 1Z"
												strokeLinecap="round"
												strokeLinejoin="round" />
										</svg>
									}

								</span>
							);
						})
					}
				</div>
			</div>
		</S.ColoredSelect>
	);
};

export default ColoredSelect;